export const chaosActionsSelector = (store) => store.chaos.actions;
export const chaosRewardsSelector = (store) => store.chaos.twitchRewards;
export const chaosSyncReportSelector = (store) => store.chaos.syncReportByActionKey;
export const chaosClientStatusSelector = (store) => store.chaos.clientStatus;
export const chaosConnectDataSelector = (store) => store.chaos.connectData;
export const chaosLogsSelector = (store) => store.chaos.logs;

export const chaosIsLoadingActionsSelector = (store) => store.chaos.isLoadingActions;
export const chaosIsLoadingRewardsSelector = (store) => store.chaos.isLoadingRewards;
export const chaosIsSyncingTwitchRewardsSelector = (store) => store.chaos.isSyncingTwitchRewards;
export const chaosIsLoadingStatusSelector = (store) => store.chaos.isLoadingStatus;
export const chaosIsLoadingConnectTokenSelector = (store) => store.chaos.isLoadingConnectToken;
